import { methodTypeToIconMap, TwoFAType } from '../../domain/two-factor';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { FormValueControl, getFormControlProvider } from '@ppl/utils/form.utils';
import { MemoizeLast } from '@ppl/utils/memoize.utils';
import type { PplRadioChange } from '@ppl/ui/radio';
import type { TwoFAMethod } from '../../domain/two-factor';

@Component({
  selector: 'ppl-two-factor-method-selector',
  templateUrl: './two-factor-method-selector.component.html',
  styleUrls: ['./two-factor-method-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    getFormControlProvider(() => TwoFactorMethodSelectorComponent)
  ],
  standalone: false
})
@FormValueControl()
export class TwoFactorMethodSelectorComponent {

  @Input() value: number;
  @Input() methods: TwoFAMethod[];

  @Output() valueChange = new EventEmitter<number>();

  TwoFAType = TwoFAType;

  @MemoizeLast<TwoFactorMethodSelectorComponent>(['methods'])
  get options(): TwoFactorMethodSelectorOption[] {
    return this.methods.map(method => this.createMethodOption(method));
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  onValueChange(change: PplRadioChange) {
    this.valueChange.emit(change.value);
  }

  createMethodOption(method: TwoFAMethod): TwoFactorMethodSelectorOption {
    const { id, type, value, display_name } = method;
    return {
      id,
      type,
      icon: methodTypeToIconMap[method.type],
      name: display_name,
      value: value && value.length
        ? value[0]
        : null
    };
  }
}

export interface TwoFactorMethodSelectorOption {
  id: number;
  type: TwoFAType;
  icon: string;
  name: string | null;
  value: string | null;
}
